import React, { useEffect, useState } from "react";
import {
  IAgendamentoDTO,
  IAtendimentoDomiciliarForm,
} from "../../../types/agendamento";
import { Ibge } from "../../../services/Ibge";
import { ISelectOptions } from "../../../types/inputs";
import { useContextSite } from "../../../context/Context";
import { Agendamento } from "../../../services/Agendamento";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { maskPhone } from "../../../utils/masks";
import { ViaCep } from "../../../services/ViaCep";
import { useSessionStorage } from "../../../hooks/useSessionStorage";
import { EstadosEnum } from "../../../enums/estados";
import { Municipio } from "../../../services/Municipio";
import { resetValues } from "../../../utils/resetObject";

export const useAddressRegistration = () => {
  const [form, setForm] = useState<IAtendimentoDomiciliarForm>(
    {} as IAtendimentoDomiciliarForm
  );
  const { setIsLoad } = useContextSite();
  const [agendamentoSession, setAgendamentoSession] =
    useSessionStorage("agendamentoSession");
  const [isDisabled, setIsDisabled] = useState(false);
  const [cidadesOptions, setCidadesOptions] = useState<ISelectOptions[]>([]);
  const navigate = useNavigate();
  const [ufOptions, setUfOptions] = useState<ISelectOptions[]>([]);
  const { uuidAgendamento } = useParams();
  const [agendamento, setAgendamento] = useState<IAgendamentoDTO>(
    {} as IAgendamentoDTO
  );
  const [isChecked, setIsChecked] = useState(false);

  function handleSubmit(e: React.SyntheticEvent) {
    e.preventDefault();

    setIsLoad(true);

    const PAYLOAD = { ...form, uuid: uuidAgendamento };

    Agendamento.putAddress(PAYLOAD)
      .then(({ data }) => {
        toast.success("Endereco cadastrado com sucesso!");
        if (agendamentoSession?.reagendamento) {
          setAgendamentoSession({
            ...agendamentoSession,
            uuidAgendamento: PAYLOAD.uuid,
          });
          navigate(`/agendamento/${PAYLOAD.uuid}/confirmar-horario`);
          return;
        }

        navigate(`/agendamento/${uuidAgendamento}/pagamento`);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  function handlePhone(e: string) {
    const newPhoneValue = maskPhone(e);
    setForm((prev) => ({ ...prev, telefone: newPhoneValue }));
  }

  useEffect(() => {
    // Ibge.UFs()
    //   .then(({ data }) => {
    //     const options = data
    //       .map((item) => ({
    //         value: item.sigla,
    //         label: item.sigla,
    //         element: item,
    //       }))
    //       .sort(compararPorSigla);

    //     setUfOptions(options);
    //   })
    //   .catch((erro) => toast.error("Erro ao requisitar as UFs"));

    const options = Object.values(EstadosEnum).map((e) => ({
      value: e,
      label: e,
    }));

    setUfOptions(options);
  }, []);

  useEffect(() => {
    if (uuidAgendamento) {
      Agendamento.getById({ uuid: uuidAgendamento })
        .then(({ data }) => {
          setAgendamento(data);
        })
        .catch(
          ({
            response: {
              data: { mensagem },
            },
          }) => toast.error(mensagem)
        );
    }
  }, [uuidAgendamento]);

  function handleCep() {
    if (form?.endereco?.cep?.length === 9) {
      setIsLoad(true);
      setTimeout(() => {
        ViaCep.get(form?.endereco?.cep)
          .then(({ data }) => {
            setForm((prev) => ({
              ...prev,
              endereco: {
                logradouro: data.logradouro,
                bairro: data.bairro,
                cidade: data.localidade,
                uf: data.uf,
                cep: form?.endereco?.cep,
              },
            }));

            // if (data?.localidade !== agendamento?.cliente?.endereco?.cidade) {
            //   toast.error("Endereço fora da cidade escolhida para atendimento");
            //   setIsDisabled(true);

            //   return;
            // }

            setIsDisabled(false);
          })
          .catch((erro) => toast.error("Cep não encontrado"))
          .finally(() => setIsLoad(false));
      }, 1000);
    }
  }

  useEffect(() => {
    if (form?.endereco?.uf) {
      // Ibge.CidadesPorEstado({ sigla: form.endereco.uf })
      //   .then(({ data }) => {
      //     const options = data.map((item) => ({
      //       value: item.nome,
      //       label: item.nome,
      //       element: item,
      //     }));
      //     setCidadesOptions(options);
      //   })
      //   .catch((erro) => toast.error("Erro ao requisitar as cidades"));
      Municipio.get({ size: 999, estado: form.endereco.uf as EstadosEnum })
        .then(({ data }) => {
          const options = data.content.map((item) => ({
            value: item.nome,
            label: item.nome,
            element: item,
          }));
          setCidadesOptions(options);
        })
        .catch((erro) => toast.error("Erro ao requisitar as cidades"));
    }
  }, [form?.endereco?.uf]);

  useEffect(() => {
    if (isChecked) {
      setIsLoad(true);
      setForm((prev) => ({
        uuid: uuidAgendamento,
        nome: agendamento?.cliente?.nome,
        telefone: maskPhone(agendamento?.cliente?.telefone),
        endereco: agendamento?.cliente?.endereco,
      }));
      setTimeout(() => {
        setIsLoad(false);
      }, 1000);
      return;
    }

    const dataEmpty = resetValues(form);

    setForm(dataEmpty);
    setIsLoad(false);
  }, [isChecked]);

  return {
    form,
    setForm,
    handleSubmit,
    ufOptions,
    handlePhone,
    handleCep,
    cidadesOptions,
    isDisabled,
    isChecked,
    setIsChecked,
  };
};
